const unauthenticatedUserName = 'Unknown';

export default unauthenticatedUserName;
